export default __webpack_public_path__ + "static/media/neuro.3e917d03.svg";